<template>
    <el-row>
        <el-row>
            <el-button @click="add">创建+</el-button>
        </el-row>
        <el-row>
            <el-input placeholder="请输入训练营名称" style="width: 200px;margin-right: 10px;" v-model="scenarioName" />
            <el-button @click="demand">筛选</el-button>
            <el-button @click="daochu">导出excel</el-button>
        </el-row>
        <el-row>
            <el-table :data="tableData">
                <el-table-column label="序号" prop='id'></el-table-column>
                <el-table-column label="训练营名称" prop="scenarioName"></el-table-column>
                <el-table-column label="参与人数">
                    <template slot-scope="scope">
                        {{ scope.row.personNum }}人
                    </template>
                </el-table-column>
                <el-table-column label="剧本天数">
                    <template slot-scope="scope">
                        {{ scope.row.dayNumTotal }}天
                    </template>
                </el-table-column>
                <el-table-column label="浏览人数">
                    <template slot-scope="scope">
                        {{ scope.row.visitorsNumber }}人
                    </template>
                </el-table-column>
                <el-table-column label="上下架状态">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.scenarioEnable" active-color="#13ce66" inactive-color="#ff4949"
                            :active-value="0" :inactive-value="1" @change="disSwitch(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="发布状态">
                    <template slot-scope="scope">
                        {{ scope.row.releasePhase == 0 ? '未发布' : '已发布' }}
                    </template>
                </el-table-column>
                <el-table-column label="创建人" prop="createPerson"></el-table-column>
                <el-table-column label="创建日期" prop="createTime"></el-table-column>
                <el-table-column label="操作" width="250px">
                    <template slot-scope="scope">
                        <el-button @click="par(scope.row)" type="text" style="color: #71b621;">
                            参与人员
                        </el-button>
                        <el-button @click="per(scope.row)" type="text" style="color: #16a8ed;">
                            队员心得
                        </el-button>
                        <el-button @click="editor(scope.row)" type="text" style="color: pink;">
                            编辑
                        </el-button>
                        <el-button @click="toDetails(scope.row)" type="text" style="color: blue;">
                            明细
                        </el-button>
                        <el-button v-if="scope.row.releasePhase == 0" @click="fabu(scope.row)" type="text"
                            style="color: #8412fb;">
                            发布
                        </el-button>
                        <el-button @click="del(scope.row)" type="text" style="color: #d80090;">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <div style="margin: 20px 30%;">
            <el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
                :page-size="pageSize" :page-sizes="[30, 50, 100]" :total="total" :current-page.sync="pageNum"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
        <el-dialog :visible.sync="dialogVisible" :title="title" center width="60%">
            <el-form label-position="right" label-width="100px" :model="info" ref="info">
                <el-form-item label="训练营名称" prop="scenarioName" :rules="[{
                    required: true, message: '请输入训练营名称', trigger: 'change'
                }]">
                    <el-input v-model="info.scenarioName" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="分类" prop="arr" :rules="[{
                    required: true, message: '请选择分类', trigger: 'change'
                }]">
                    <el-cascader v-model="info.arr" :options="options" :props="props" style="width: 100%;">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="目标人群:" prop="labelIds" :rules="[{
                    required: true, message: '请输入目标人群', trigger: 'change'
                }]">
                    <el-cascader v-model="info.labelIds" :options="options2" :props="props2" style="width: 100%;" clearable>
                    </el-cascader>
                </el-form-item>
                <el-form-item label="剧本主图:" prop="scenarioPic" :rules="[{
                    required: true, message: '请上传主图', trigger: 'change'
                }]">
                    <div style="display: flex;align-items: center;">
                        <el-upload :class="{ hide: hideUpload }" :action="uploadUrl" list-type="picture-card" :limit="1"
                            :on-success="getPictrueURL" accept=".jpg,.png" :file-list="info.scenarioPic"
                            :on-remove="handleRemove">
                            <i class="el-icon-plus" />
                        </el-upload>
                        <el-button @click="openImg" style="margin-left: 20px;" type="text">图片库选择</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="策略描述:" prop="scenarioDescription" :rules="[{
                    required: true, message: '请输入策略描述', trigger: 'change'
                }]">
                    <el-input v-model="info.scenarioDescription" type="textarea" maxlength="800" show-word-limit autosize>
                    </el-input>
                </el-form-item>
                <el-form-item label="IP定位:" prop="scenarioLocation" :rules="[{
                    required: true, message: '请输入IP定位', trigger: 'change'
                }]">
                    <el-input v-model="info.scenarioLocation" type="textarea" maxlength="800" show-word-limit autosize>
                    </el-input>
                </el-form-item>
                <el-form-item label="USB卖点:">
                    <div v-for="(item, index) in info.arr2" :key="index">
                        <el-form-item :label="(index + 1) > 9 ? (index + 1).toString() : '0' + (index + 1)" label-width="40px"
                            :prop="`arr2.${index}.scenarioSellingPoint`" :rules="[{
                                required: true, message: '请输入USB卖点', trigger: 'change'
                            }]">
                            <div style="display: flex;">
                                <el-input v-model="item.scenarioSellingPoint" maxlength="200" show-word-limit autosize>
                                </el-input>
                                <el-button icon="el-icon-delete" type="text" @click="del2(index)" v-if="info.arr2.length > 1"
                                    style="margin-top: 10px;">
                                </el-button>
                            </div>
                        </el-form-item>
                    </div>
                    <span>最多添加10条</span>
                    <el-button @click="add2" icon="el-icon-plus" v-if="info.arr2.length < 10"></el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="infor" @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="sumbit">确认</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-drawer title="选择图片" :visible.sync="isSelectPicture" direction="rtl" size="40%">
            <SelectPicture :imgNum="1" @imgList='getImg' />
        </el-drawer>
    </el-row>
</template>

<script>
import httpClient from '../../util/request.js';
import SelectPicture from '../../components/SelectPicture/index.vue'
export default {
    components: {
        SelectPicture
    },
    data() {
        return {
            isSelectPicture: false,
            uploadUrl: httpClient.imgUrl,
            hideUpload: false,
            dialogDisplay: false,
            scenarioName: "",
            pageNum: 1,
            pageSize: 30,
            total: 0,
            tableData: [],
            dialogVisible: false,
            dialogVisible2: false,
            title: '',
            info: {
                id: '',
                scenarioName: "", //剧本名称
                arr: [], //品类编号
                labelIds: [], //标签集合
                scenarioPic: [], //剧本主图
                scenarioDescription: "", //剧本描述
                scenarioLocation: "", //ip定位 
                arr2: [{
                    scenarioSellingPoint: "", //usb卖点
                }]
            },
            info2: {
                id: '',
                dayNumber: '',
                scenarioProgramme: '',
            },
            options: [],
            options2: [],
            props2: {
                value: "id",
                label: "name",
                children: "sonList",
                multiple: true,
            },
            props: {
                value: "id",
                label: "name",
                children: "children",
            },
            scenarioTypes: [{
                value: '05',
                label: '构建信任'
            },
            {
                value: '06',
                label: '拓新吸粉'
            },
            {
                value: '08',
                label: '产品种草'
            },
            {
                value: '07',
                label: '服务私聊'
            },
            {
                value: '09',
                label: '课程学习'
            }
            ]
        }
    },
    methods: {
        openImg() {
            this.isSelectPicture = true
        },
        getImg(e) {
            this.info.scenarioPic = []
            this.info.scenarioPic.push({
                url: e
            })
            this.isSelectPicture = false
        },
        fabu(row) {
            this.$confirm('此操作后该训练营将不可以添加明细, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post('/api/plant/positions/updateScenario', {
                    "id": row.id,
                    'releasePhase': 1
                }).then(res => {
                    if (res.data.status == 0) {
                        this.$message.success('发布成功')
                        this.getInfo()
                    } else {
                        this.$message.success('发布失败')
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消发布'
                });
            });
        },
        //添加USB
        add2() {
            this.info.arr2.push({
                scenarioSellingPoint: ''
            })
        },
        //删除usb
        del2(index) {
            this.info.arr2.splice(index, 1)
        },
        //创建
        add() {
            this.dialogVisible = true
            this.title = '创建训练营'
            this.info = {
                id: '',
                scenarioName: "", //剧本名称
                arr: [], //品类编号
                labelIds: [], //标签集合
                scenarioPic: [], //剧本主图
                scenarioDescription: "", //剧本描述
                scenarioLocation: "", //ip定位 
                arr2: [{
                    scenarioSellingPoint: "", //usb卖点
                }],
            }
            this.hideUpload = false
        },
        toDetails(row) {
            this.$router.push({
                path: './cliDetails',
                query: {
                    id: row.id,
                    releasePhase: row.releasePhase
                }
            })
        },
        //参与人员
        par(row) {
            this.$router.push({
                path: './par',
                query: {
                    id: row.id
                }
            })
        },
        //队员心得
        per(row) {
            this.$router.push({
                path: './per',
                query: {
                    id: row.id
                }
            })
        },
        //状态
        disSwitch(row) {
            this.$http.post('/api/plant/positions/updateScenario', {
                "id": row.id,
                "scenarioEnable": row.scenarioEnable == 0 ? 0 : 1
            }).then(res => {
                if (res.data.status == 0) {
                    this.getInfo()
                }
            })
        },
        //删除
        del(row) {
            this.$confirm('此操作将永久删除该训练营, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post("/api/plant/positions/updateScenario", {
                    id: row.id,
                    deleteStatus: 1
                }).then(res => {
                    if (res.data.status == 0) {
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getInfo()
                    } else {
                        this.$message({
                            type: 'error',
                            message: '删除失败'
                        });
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //编辑
        editor(row) {
            this.title = '修改训练营'
            this.dialogVisible = true
            let arr2 = []
            row.scenarioSellingPoint.split('&').forEach(i => {
                arr2.push({
                    scenarioSellingPoint: i
                })
            })
            this.info = {
                id: row.id,
                scenarioName: row.scenarioName,
                arr: [row.primaryType, row.secondary],
                labelIds: row.labelVosArr,
                scenarioPic: [], //剧本主图
                scenarioPic: [{
                    url: row.scenarioPic
                }],
                scenarioDescription: row.scenarioDescription, //剧本描述
                scenarioLocation: row.scenarioLocation, //ip定位 
                arr2: arr2,
            }
            this.hideUpload = this.info.scenarioPic.length >= 1
        },

        //查询
        demand() {
            this.getInfo()
        },
        daochu() {
            this.$http.post('/api/statistics/knowledgeBase/exportTrain', {
                "scenarioName": this.name,
            }, {
                responseType: 'blob'
            }).then(res => {
                this.$message({
                    type: 'info',
                    message: '正在导出表格'
                });
                const link = document.createElement('a');
                let blob = new Blob([res.data], {
                    type: 'application/vnd.ms-excel'
                });
                link.style.display = 'none';
                //设置连接
                link.href = URL.createObjectURL(blob);
                link.download = '训练营列表';
                document.body.appendChild(link);
                //模拟点击事件
                link.click();
                window.URL.revokeObjectURL(link.href);
                link.remove();
            }).catch((error) => {
                this.$message.error("发生了一些错误:" + error);
            })
        },
        sumbit() {
            let labelIds = []
            if (this.info.labelIds.length > 0) {
                this.info.labelIds.forEach(i => {
                    labelIds.push(i[1])
                })
            }
            let scenarioSellingPoint = []
            this.info.arr2.forEach(i => {
                scenarioSellingPoint.push(i.scenarioSellingPoint)
            })
            this.$refs.info.validate(vai => {
                if (vai) {
                    if (this.title == '创建训练营') {
                        this.$http.post('/api/plant/positions/insertScenario', {
                            "scenarioType": "05", //类型
                            "scenarioName": this.info.scenarioName, //剧本名称
                            "primaryType": this.info.arr[0], //一级品类编号
                            "secondary": this.info.arr[1], //二级品类编号
                            "labelIds": labelIds, //标签集合
                            "createPerson": this.$store.state.userInfo.id, //创建人ID
                            "scenarioPic": this.info.scenarioPic[0].url, //剧本主图
                            "scenarioDescription": this.info.scenarioDescription, //剧本描述
                            "scenarioLocation": this.info.scenarioLocation, //IP定位
                            "scenarioSellingPoint": scenarioSellingPoint.join('&') //USB卖点
                        }).then(res => {
                            if (res.data.status == 0) {
                                this.$message.success('添加成功')
                                this.dialogVisible = false
                                this.getInfo()
                            } else {
                                this.$message.error('添加失败')
                            }
                        })
                    } else {
                        this.$http.post('/api/plant/positions/updateScenario', {
                            "id": this.info.id,
                            "scenarioType": "05", //类型
                            "scenarioName": this.info.scenarioName, //剧本名称
                            "primaryType": this.info.arr[0], //一级品类编号
                            "secondary": this.info.arr[1], //二级品类编号
                            "labelIds": labelIds, //标签集合
                            "createPerson": this.$store.state.userInfo.id, //创建人ID
                            "scenarioPic": this.info.scenarioPic[0].url, //剧本主图
                            "scenarioDescription": this.info.scenarioDescription, //剧本描述
                            "scenarioLocation": this.info.scenarioLocation, //IP定位
                            "scenarioSellingPoint": scenarioSellingPoint.join('&') //USB卖点
                        }).then(res => {
                            if (res.data.status == 0) {
                                this.$message.success('编辑成功')
                                this.dialogVisible = false
                                this.getInfo()
                            } else {
                                this.$message.success('编辑失败')
                            }
                        })
                    }
                }
            })
        },
        //款式主图相关方法
        getPictrueURL(response, file, fileList) {
            if (response.status == 1) {
                this.$message.error(response.msg)
                fileList.pop()
            } else {
                this.info.scenarioPic.push({
                    url: response.data
                })
                this.hideUpload = fileList.length >= 1
            }
        },
        // 款式主图预览
        handlePictureCardPreview(file) {
            this.info.scenarioPic = []
            this.info.scenarioPic.push(file.url);
            this.dialogDisplay = true;
        },
        // 款式主图上传框删除一个图片
        handleRemove(file, fileList) {
            this.info.scenarioPic = []
            this.hideUpload = false
        },
        // 款式主图预览dialog关闭时的回调
        imagePrevClosed() {
            this.info.scenarioPic = []
        },
        getInfo() {
            this.$http.post('/api/plant/positions/selectScenario', {
                "orderType": 0,
                "scenarioType": '05',
                "scenarioName": this.scenarioName,
                "pageNum": this.pageNum,
                "pageSize": this.pageSize
            }).then(res => {
                if (res.data.data.list.length > 0) {
                    res.data.data.list.forEach(i => {
                        i.labelVosArr = []
                        i.labelVosName = ''
                        let labelVosName = []
                        if (i.labelVos.length > 0) {
                            i.labelVos.forEach(item => {
                                i.labelVosArr.push([item.parentLabelId, item.labelId])
                                labelVosName.push(item.labelName)
                                i.labelVosName = labelVosName.join(',')
                            })
                        }
                    })
                }
                this.total = res.data.data.total
                this.tableData = res.data.data.list
            })
        },
        //获取销售人群
        getInfo2() {
            let arr = []
            this.$http.get("/api/plant/clrLabel/selectLabelList", {}).then((res) => {
                res.data.data.forEach((item) => {
                    item.sonList.forEach(i => {
                        arr.push({
                            id: i.memberLabelId,
                            name: i.name,
                            sonList2: i.sonList
                        })
                    })
                });
                arr.forEach(i2 => {
                    i2.sonList = []
                    i2.sonList2.forEach(i3 => {
                        i2.sonList.push({
                            id: i3.memberLabelId,
                            name: i3.name
                        })
                    })
                })
                this.options2 = arr
            });
        },
        //获取分类
        getpaiCategory() {
            this.$http
                .get(
                    "/api/product/productCategory/paiCategory?pageSize=999&pageNum=1&paiStatus=1", {}
                )
                .then((res) => {
                    this.options = res.data.data.list;
                });
        },
        handleSizeChange(val) {
            this.pageNum = 1;
            this.pageSize = val;
            this.getInfo()
        },
        //页数
        handleCurrentChange(val) {
            this.pageNum = val;
            this.getInfo()
        },
    },
    created() {
        this.getInfo()
        this.getpaiCategory()
        this.getInfo2()
    }
}
</script>

<style scoped>
::deep .hide .el-upload--picture-card {
    display: none;
}
</style>